import React from 'react';
import {Box, Typography, Avatar, Drawer, Divider,IconButton} from '@mui/material';
import { Home,Build,Instagram,Facebook } from '@mui/icons-material';
import dev from '../../other/image/dev.jpeg';
import Footer from '../utils/footer';
import Header from '../utils/headerinfo';
import {gsap} from 'gsap';
import { Page } from '../utils/datautils';

const clr = ['#ed2626','#ed6226','#eda726', '#bfbc17', '#71bf17', '#17bf68', '#17bcbf', '#2274e0', '#5733d6', '#a43fcc', '#cc3bb4','#d43769'];

let contributor = [
  {
    nama:'Arrijal Amar Ma`ruf',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Komunikasi & Informasi',
    Angkatan:'2019',
    sosmed:{instagram:'ama.rrijal',
            facebook:'amar.rijal.336'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: dev,
  },
  {
    nama:'Abdullah Faqih',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Teknik Industri',
    Angkatan:'2019',
    sosmed:{instagram:'qihh27'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Chaidhir Rais Sayyaf',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Ekonomi & Bisnis',
    Angkatan:'2020',
    sosmed:{instagram:'chaidhir_rs'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Fauzan Wahyu Effrilians',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Teknik Kimia',
    Angkatan:'2019',
    sosmed:{instagram:'wahyu.eff'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Silvia Puspita Sari',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Farmasi',
    Angkatan:'2019',
    sosmed:{instagram:'silsilvia982'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Feliya Anisaa Widyaputri',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Komunikasi & Informasi',
    Angkatan:'2019',
    sosmed:{instagram:'feliyanisaa_', facebook:'feliya anisaa'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Nurbaiti Dyan Rahmadika',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Ekonomi & Bisnis',
    Angkatan:'2019',
    sosmed:{instagram:'dyanrhmaa_'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Muhammad Mumtaz Ramadhani',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Ilmu Kesehatan',
    Angkatan:'2019',
    sosmed:{instagram:'mumtazdhn'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Ulfi Nariswari Az-Zahra',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Komunikasi & Informasi',
    Angkatan:'2019',
    sosmed:{instagram:'ulfinzhr'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Aisyah Fajar Rini',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Farmasi',
    Angkatan:'2019',
    sosmed:{instagram:'Aisyatuun'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Arini Nur Afidati',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Agama Islam',
    Angkatan:'2019',
    sosmed:{instagram:'arininurafi'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Dhesy Hamdan Lafaiz',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Ilmu Kesehatan',
    Angkatan:'2020',
    sosmed:{instagram:'dhesy_hamdan'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Rizka Safira Fanani',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Agama Islam',
    Angkatan:'2020',
    sosmed:{instagram:'rizkasafira.f25'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Asep Nur Amin',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Agama Islam',
    Angkatan:'2020',
    sosmed:{instagram:'asep_nuramin'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Inayah Septiani',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Keguruan & Ilmu Pendidikan',
    Angkatan:'2019',
    sosmed:{instagram:'inayahss._'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Rana Dhiya` Nadhiifah',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Ilmu Kesehatan',
    Angkatan:'2019',
    sosmed:{instagram:'ran_dhifah01'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Adityo Wiwit Kurniawan',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Agama Islam',
    Angkatan:'2020',
    sosmed:{instagram:'adityo_wit'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
  {
    nama:'Zulfa Izzatun Nikmah',
    kampus: 'Universitas Muhammadiyah Surakarta',
    fakultas:'Keguruan & Ilmu Pendidikan',
    Angkatan:'2020',
    sosmed:{instagram:'Zulfaizza_12'},
    background:clr[Math.floor(Math.random()*(clr.length-1))],
    image: null,
  },
]

export default function Dev() {
  const[open, setOpen]=React.useState();
  const[data, setData]=React.useState(0);
  React.useEffect(()=>{
    gsap.from('#team-id',{opacity:0,y:150, duration:1, ease:'elastic'});
    gsap.from('#team-member',{opacity:0,y:150, duration:1, delay:1, ease:'elastic'});
  },[])
  const handleMenuClose = () => {
    setOpen(null);
  }
  
  const openUp = (
    <Box style={{width:'100vw', background:contributor[data].background}}>
      <Box justifyContent='center' alignItems='center' display='flex'>
        {(contributor[data].image)? (<Avatar alt='foto' src={contributor[data].image} sx={{background:'rgba(0,0,0,0.2)',width:{xs:'20vw',sm:'8vw',md:'3vw'},height:{xs:'20vw',sm:'8vw',md:'3vw'}}}/>):(<Avatar sx={{background:'rgba(0,0,0,0.2)',width:{xs:'20vw',sm:'8vw',md:'3vw'},height:{xs:'20vw',sm:'8vw',md:'3vw'}}}>{contributor[data].nama.charAt(0)}</Avatar>)}
        <Box style={{marginLeft:'5px', marginTop:'10px',marginBottom:'10px',color:'white'}}>
          <Typography variant='body1' sx={{textAlign:'left',marginLeft:'5px'}}>
            {contributor[data].nama}
          </Typography>
          <Divider/>
          <Typography variant='body1' sx={{textAlign:'left',marginLeft:'5px'}}>
            {contributor[data].kampus}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Box borderRadius='10% 10% 0% 0%' borderTop={2} borderColor='rgba(0,0,0,0.1)' justifyContent='center' alignItems='center' display='flex' flexWrap='wrap' style={{background:'rgba(0,0,0,0.2)'}}>
          <Box sx={{color:'white'}}>
            <Typography variant='body2' style={{textAlign:'center'}}>
              <b>Fakultas: </b>
            </Typography>
            <Typography variant='body2' style={{textAlign:'center'}}>
              <b>Angkatan: </b>
            </Typography>
          </Box>
          <Box sx={{color:'white'}}>
            <Typography variant='body2' style={{marginLeft:'10px'}}>
              {contributor[data].fakultas}
            </Typography>
            <Typography variant='body2' style={{marginLeft:'10px'}}>
              {contributor[data].Angkatan}
            </Typography>
          </Box>
          <Box justifyContent='center' alignItems='center' display='flex' flexWrap='wrap' style={{width:'100%', color:'white'}}>
            {(contributor[data].sosmed.instagram)?(<IconButton classes='a' color='inherit' rel="noreferrer" target='_blank' href={'https://instagram.com/'+contributor[data].sosmed.instagram}><Instagram/></IconButton>):(<></>)}
            {(contributor[data].sosmed.facebook)?(<IconButton classes='a' color='inherit' rel="noreferrer" target='_blank' href={'https://facebook.com/'+contributor[data].sosmed.facebook}><Facebook/></IconButton>):(<></>)}
          </Box>
        </Box>
      </Box>
    </Box>
  )
  return(
    <>
      <Header path1={Page.HOME} path2={Page.ADMIN} icon1={<Home />} icon2={<Build />}
        desc1='Home' desc2='Data Center'/>
      <Drawer anchor='bottom' open={Boolean(open)} onClose={handleMenuClose}>
        {openUp}
      </Drawer>
      <Box style={{height:'70vh'}}>
        <Box id="team-id" justifyContent='center' alignItems='flex-start' display='flex' flexWrap='wrap'>
          <Typography variant='h1' style={{textAlign:'center', marginTop:'120px',fontFamily:'Segoe UI',fontWeight:500,textShadow: '2px 10px 4px #a6a6a6'}}>
            Our Teams
            <Box style={{height:'2px',width:'100%',background:'radial-gradient(circle at center, #000000 1%, transparent 100%)'}}/>
          </Typography>
        </Box>
        <Box id='team-member' justifyContent='center' alignItems='flex-start' display='flex' flexWrap='wrap' style={{width:'100%',marginLeft:'12px',marginRight:'12px', marginTop:'50px', position:'relative',top:'100px'}}>
          {contributor.map(
            (a, i) => (
              (a.image)? (
                <Avatar key={i} alt="Profile" src={a.image} sx={{backgroundColor:a.background,marginRight:'10px',marginTop:'10px'}} onClick={a=>{setData(i);setOpen(true)}}/>
              ):(
                <Avatar key={i} alt="Profile" src={null} sx={{backgroundColor:a.background,marginRight:'10px',marginTop:'10px'}} onClick={a=>{setData(i);setOpen(true)}}>{a.nama.charAt(0)}</Avatar>
              )
            )
          )}
        </Box>
        <Box justifyContent='center' alignItems='center' display='flex' style={{width:'100%',marginTop:'50px', marginBottom:'50px', position:'relative', top:'20vh'}}>
          <Box borderRadius={5} border={2} borderColor='#ff6600' display='flex' style={{width:'90%', background:'#ff9933'}}>
            <Typography style={{textAlign:'center',color:'white',padding:"10px"}}>
              <span style={{fontWeight:900,fontSize:'30px'}}>*</span>Jika terdapat kesalahan/error dalam pengaksesan web ini, tolong segera hubungi <a href='mailto:Rijalamar29@gmail.com'>Rijalamar29@gmail.com</a> atau via facebook: <a target='_blank' rel="noreferrer" href='https://facebook.com/amar.rijal.336'>Amar Rijal</a>.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box style={{height:'40vh', width:'100vw', background: 'radial-gradient(ellipse at bottom, #000000, transparent 63%)'}}/>
      <Footer />
    </>
  )
}
